import ButtonModel from '../../Button/enums/ButtonModel.enum';

export function determineNavButtonType(target: string, page?: string): string {
  if (page === target) {
    return ButtonModel.ACTIVE_ICON_BUTTON;
  }

  return ButtonModel.PASSIVE_ICON_BUTTON;
}
